export const FREE_SHIPPING_THRESHOLD = 5500;
